import { ImageStyled } from './Icon.styles';

// eslint-disable-next-line no-shadow
export type IconTypes =
  | 'anchor'
  | 'bid'
  | 'clock'
  | 'close'
  | 'checked'
  | 'cert'
  | 'copy'
  | 'delete'
  | 'document'
  | 'downArrow'
  | 'exchange'
  | 'flag'
  | 'forbidden'
  | 'gallery'
  | 'gear'
  | 'gearWrench'
  | 'global'
  | 'heart'
  | 'highVisibility'
  | 'insight'
  | 'loupe'
  | 'lowPrice'
  | 'magnifier'
  | 'message'
  | 'minus'
  | 'money'
  | 'info'
  | 'invisible'
  | 'invoice'
  | 'key'
  | 'pencil'
  | 'plus'
  | 'print'
  | 'prize'
  | 'ranking'
  | 'rankingCup'
  | 'renew'
  | 'rightArrow'
  | 'travelling'
  | 'save'
  | 'ship'
  | 'statistics'
  | 'star'
  | 'starWithOutLine'
  | 'warningSign'
  | 'support'
  | 'visible'
  | 'warningSign'
  | 'worker'
  | 'workflow'
  | 'wrench'
  | 'upArrow'
  | 'user'
  | 'cancel';

export type IconColors = 'lightGray' | 'gray' | 'black' | 'white' | 'yellow';

interface IconProps {
  alt?: string;
  className?: string;
  color?: IconColors;
  onClick?: () => void;
  size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  type: IconTypes;
  tooltip?: string;
}

const icons: { [key in IconTypes]: string } = {
  anchor: '/icons/anchor.svg',
  bid: '/icons/bid.svg',
  cancel: '/icons/cancel.svg',
  cert: '/icons/cert.svg',
  close: '/icons/close.svg',
  clock: '/icons/sandClock.svg',
  checked: '/icons/checked.svg',
  copy: '/icons/copy.svg',
  delete: '/icons/delete.svg',
  document: '/icons/document.svg',
  downArrow: '/icons/downArrow.svg',
  exchange: '/icons/exchange.svg',
  flag: '/icons/flag.svg',
  forbidden: '/icons/forbidden.svg',
  gallery: '/icons/gallery.svg',
  gear: '/icons/gear.svg',
  gearWrench: '/icons/gearWrench.svg',
  global: '/icons/global.svg',
  heart: '/icons/heart.svg',
  highVisibility: '/icons/highVisibility.svg',
  insight: 'icons/insight.svg',
  key: '/icons/key.svg',
  loupe: '/icons/loupe.svg',
  lowPrice: '/icons/lowPrice.svg',
  magnifier: '/icons/magnifier.svg',
  message: '/icons/envelope.svg',
  minus: '/icons/minus.svg',
  money: '/icons/money.svg',
  info: '/icons/info.svg',
  invisible: 'icons/invisible.svg',
  invoice: '/icons/invoice.svg',
  pencil: '/icons/pencil.svg',
  plus: '/icons/plus.svg',
  print: '/icons/print.svg',
  prize: '/icons/prize.svg',
  ranking: '/icons/ranking.svg',
  rankingCup: '/icons/rankingCup.svg',
  renew: '/icons/renew.svg',
  rightArrow: '/icons/rightArrow.svg',
  travelling: '/icons/travelling.svg',
  save: '/icons/save.svg',
  ship: '/icons/ship.svg',
  statistics: '/icons/statistics.svg',
  star: '/icons/star.svg',
  starWithOutLine: '/icons/star1.svg',
  support: '/icons/support.svg',
  upArrow: '/icons/upArrow.svg',
  user: '/icons/user.svg',
  visible: '/icons/visible.svg',
  warningSign: '/icons/warningSign.svg',
  worker: '/icons/worker.svg',
  workflow: '/icons/workflow.svg',
  wrench: '/icons/wrench.svg',
};

const Icon = ({
  alt = 'icon',
  className,
  color = 'gray',
  onClick,
  size,
  type,
  tooltip,
}: IconProps): JSX.Element => {
  return (
    <ImageStyled
      alt={alt}
      src={icons[type]}
      size={size}
      data-color={color}
      className={className}
      onClick={onClick}
      data-tip={tooltip}
    />
  );
};

export default Icon;
